import { IconComponentProps } from '../IconTypes';

const SquareGantt = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M2.375 6C2.375 4.82639 3.3264 3.875 4.5 3.875H10.5C11.6736 3.875 12.625 4.82639 12.625 6C12.625 7.17361 11.6736 8.125 10.5 8.125H4.5C3.3264 8.125 2.375 7.17361 2.375 6ZM4.5 5.125C4.01675 5.125 3.625 5.51675 3.625 6C3.625 6.48325 4.01675 6.875 4.5 6.875H10.5C10.9832 6.875 11.375 6.48325 11.375 6C11.375 5.51675 10.9832 5.125 10.5 5.125H4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.375 18C2.375 16.8264 3.32639 15.875 4.5 15.875H13.5C14.6736 15.875 15.625 16.8264 15.625 18C15.625 19.1736 14.6736 20.125 13.5 20.125H4.5C3.32639 20.125 2.375 19.1736 2.375 18ZM4.5 17.125C4.01675 17.125 3.625 17.5168 3.625 18C3.625 18.4832 4.01675 18.875 4.5 18.875H13.5C13.9832 18.875 14.375 18.4832 14.375 18C14.375 17.5168 13.9832 17.125 13.5 17.125H4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M5.375 12C5.375 10.8264 6.3264 9.875 7.5 9.875H19.5C20.6736 9.875 21.625 10.8264 21.625 12C21.625 13.1736 20.6736 14.125 19.5 14.125H7.5C6.3264 14.125 5.375 13.1736 5.375 12ZM7.5 11.125C7.01675 11.125 6.625 11.5168 6.625 12C6.625 12.4832 7.01675 12.875 7.5 12.875H19.5C19.9832 12.875 20.375 12.4832 20.375 12C20.375 11.5168 19.9832 11.125 19.5 11.125H7.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SquareGantt;
